// 导入组件
import selectTree from './src/select-tree.vue'

// 为组件提供 install 安装方法，供按需引入
selectTree.install = function (Vue) {
  Vue.component(selectTree.name, selectTree)
}

// 默认导出组件
export default selectTree
